import { head, isNil } from 'lodash'

import { SafireSession } from '../types'

const cityValues = { Montréal: 'Montreal', Québec: 'Quebec', 'Classe virtuelle': 'Virtual class' }

export function findNextAvailableSession(sessions: SafireSession[]) {
  const today = new Date()
  const nextSession = [...sessions].sort(sessionSorterByDate).find((session) => {
    const sessionDates = session.Dates.map((date) => new Date(date)).sort(
      (a, b) => a.getTime() - b.getTime()
    )
    if (sessionDates.length === 0) {
      return false
    }

    return sessionDates[0] > today && !session.ShowAsFull
  })

  return nextSession
}

export function findFirstAvailableDate(sessions: SafireSession[], locale: string) {
  const nextAvailableSession = findNextAvailableSession(sessions)
  const city = nextAvailableSession?.City

  return nextAvailableSession
    ? `${formatDate(new Date(nextAvailableSession.Date), locale)} | ${
        nextAvailableSession.City in cityValues && locale === 'en'
          ? cityValues[nextAvailableSession.City]
          : city
      }`
    : null
}

function formatDate(date: Date, locale: string) {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }

  return locale === 'fr'
    ? new Intl.DateTimeFormat('fr-FR', options).format(date)
    : new Intl.DateTimeFormat('en-US', options).format(date)
}

export function formatDateWithoutYear(date: Date, locale: string) {
  const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric' }

  return locale === 'fr'
    ? new Intl.DateTimeFormat('fr-FR', options).format(date)
    : new Intl.DateTimeFormat('en-US', options).format(date)
}

export const sessionSorterByDate = (a: { Dates: string[] }, b: { Dates: string[] }) => {
  const testA = head(a.Dates.sort())
  const testB = head(b.Dates.sort())
  if (!isNil(testA) && !isNil(testB)) {
    if (testA < testB) {
      return -1
    }
    if (testA > testB) {
      return 1
    }
  }
  return 0
}

const DAY_MILLISECONDS = 24 * 60 * 60 * 1000
export const NEW_COURSE_THRESHOLD_MILLISECONDS = 365 * 1.5 * DAY_MILLISECONDS

export function isCourseNew(course: { CreationDate: number }) {
  return new Date().getTime() - course.CreationDate < NEW_COURSE_THRESHOLD_MILLISECONDS
}
